import { render, staticRenderFns } from "./EsgRegistration.vue?vue&type=template&id=66e5f438&"
import script from "@/scripts/Mall/ESG/EsgRegistration/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Mall/ESG/EsgRegistration/index.js?vue&type=script&lang=js&"
import style0 from "./EsgRegistration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports